webpackJsonp([35783957827783],{

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Photo = __webpack_require__(393);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _utils = __webpack_require__(394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_React$Component) {
	  _inherits(Gallery, _React$Component);
	
	  function Gallery() {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this));
	
	    _this.state = {
	      containerWidth: 0
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Gallery, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ containerWidth: Math.floor(this._gallery.clientWidth) });
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize, false);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      if (this._gallery.clientWidth !== this.state.containerWidth) {
	        this.setState({ containerWidth: Math.floor(this._gallery.clientWidth) });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event, _ref) {
	      var index = _ref.index;
	      var _props = this.props,
	          photos = _props.photos,
	          onClick = _props.onClick;
	
	      onClick(event, {
	        index: index,
	        photo: photos[index],
	        previous: photos[index - 1] || null,
	        next: photos[index + 1] || null
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$ImageComponent = this.props.ImageComponent,
	          ImageComponent = _props$ImageComponent === undefined ? _Photo2.default : _props$ImageComponent;
	      // subtract 1 pixel because the browser may round up a pixel
	
	      var width = this.state.containerWidth - 1;
	      var _props2 = this.props,
	          photos = _props2.photos,
	          columns = _props2.columns,
	          margin = _props2.margin,
	          onClick = _props2.onClick;
	
	      var thumbs = (0, _utils.computeSizes)({ width: width, columns: columns, margin: margin, photos: photos });
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-photo-gallery--gallery' },
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(c) {
	              return _this2._gallery = c;
	            } },
	          thumbs.map(function (photo, index) {
	            var width = photo.width,
	                height = photo.height;
	
	            return _react2.default.createElement(ImageComponent, {
	              key: photo.key || photo.src,
	              margin: margin,
	              index: index,
	              photo: photo,
	              onClick: onClick ? _this2.handleClick : null
	            });
	          })
	        ),
	        _react2.default.createElement('div', { style: { content: '', display: 'table', clear: 'both' } })
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react2.default.Component);
	
	Gallery.propTypes = {
	  photos: _propTypes2.default.arrayOf(_Photo.photoPropType).isRequired,
	  onClick: _propTypes2.default.func,
	  columns: _propTypes2.default.number,
	  margin: _propTypes2.default.number,
	  ImageComponent: _propTypes2.default.func
	};
	
	Gallery.defaultProps = {
	  columns: 3,
	  margin: 2
	};
	
	exports.default = Gallery;

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.photoPropType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var imgWithClick = { cursor: 'pointer' };
	
	var Photo = function (_PureComponent) {
	  _inherits(Photo, _PureComponent);
	
	  function Photo() {
	    _classCallCheck(this, Photo);
	
	    var _this = _possibleConstructorReturn(this, (Photo.__proto__ || Object.getPrototypeOf(Photo)).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Photo, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          index = _props.index,
	          photo = _props.photo;
	
	      onClick(event, { photo: photo, index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          photo = _props2.photo,
	          onClick = _props2.onClick,
	          margin = _props2.margin;
	
	      var imgStyle = { display: 'block', float: 'left', margin: margin };
	      return _react2.default.createElement('img', _extends({
	        style: onClick ? _extends({}, imgStyle, imgWithClick) : imgStyle
	      }, photo, {
	        onClick: onClick ? this.handleClick : null
	      }));
	    }
	  }]);
	
	  return Photo;
	}(_react.PureComponent);
	
	var photoPropType = exports.photoPropType = _propTypes2.default.shape({
	  src: _propTypes2.default.string.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  alt: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  srcSet: _propTypes2.default.array,
	  sizes: _propTypes2.default.array
	});
	
	Photo.propTypes = {
	  index: _propTypes2.default.number,
	  onClick: _propTypes2.default.func,
	  photo: photoPropType
	};
	
	exports.default = Photo;

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.round = round;
	exports.ratio = ratio;
	exports.computeSizes = computeSizes;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function round(value, decimals) {
	  if (!decimals) decimals = 0;
	  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	}
	
	// return two decimal places rounded number
	function ratio(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return round(width / height, 2);
	}
	
	// takes the Gallery's photos prop object, width of the container,
	// margin between photos Gallery prop, and columns Gallery prop.
	// calculates, sizes based on columns and returns the photos object with new height/width props
	function computeSizes(_ref2) {
	  var photos = _ref2.photos,
	      columns = _ref2.columns,
	      width = _ref2.width,
	      margin = _ref2.margin;
	
	  if (!width) {
	    return [];
	  }
	  // divide photos over rows, max cells based on `columns`
	  // effectively resulting in [[0, 1, 2], [3, 4, 5], [6, 7]]
	  var rows = photos.reduce(function (acc, cell, idx) {
	    var row = Math.floor(idx / columns);
	    acc[row] = acc[row] ? [].concat(_toConsumableArray(acc[row]), [cell]) : [cell]; // eslint-disable-line no-param-reassign
	    return acc;
	  }, []);
	
	  // calculate total ratio of each row, and adjust each cell height and width
	  // accordingly.
	  var lastRowIndex = rows.length - 1;
	  var rowsWithSizes = rows.map(function (row, rowIndex) {
	    var totalRatio = row.reduce(function (result, photo) {
	      return result + ratio(photo);
	    }, 0);
	    var rowWidth = width - row.length * (margin * 2);
	
	    // assign height, but let height of a single photo in the last
	    // row not expand across columns so divide by columns
	    var height = rowIndex !== lastRowIndex || row.length > 1 ? // eslint-disable-line
	    rowWidth / totalRatio : rowWidth / columns / totalRatio;
	
	    return row.map(function (photo) {
	      return _extends({}, photo, {
	        height: round(height, 1),
	        width: round(height * ratio(photo), 1)
	      });
	    });
	  });
	  return rowsWithSizes.reduce(function (acc, row) {
	    return [].concat(_toConsumableArray(acc), _toConsumableArray(row));
	  }, []);
	}

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(99);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(62);
	
	var _reactPhotoGallery = __webpack_require__(392);
	
	var _reactPhotoGallery2 = _interopRequireDefault(_reactPhotoGallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(_reactPhotoGallery2.default, { margin: '7', photos: GALLERY });
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	
	var GALLERY = [{
	  src: 'https://static.wixstatic.com/media/90a71b_8ea04cdc02ff4cc0b70c0e5006e60b27~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_0923fee7957e45c2aebea9f67619ee1d~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_a0b3a2bc49df43e8a9db362b75728627~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_2845fcc513d2461694ea474f8348927c~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_456a5ac4c7c142168f245a583e01dae3~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_71ccf2ae3f67475db14e6b3f942eb260~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_a000662a19364d13a8eb1021d9b82dbd~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_11edb521d0d7471693bbcdcb4aef37b9~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_0dc233e7a5b64f9d86873fac70f5a3ac~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_104e694bbe3146b3a8ff262645f78393~mv2_d_5692_3200_s_4_2.png'
	},
	
	//80s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_14bd2a5e38b340b0958a437e99c0eb3b~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b5bbc8ca8eac404ca515d7bfe5858b32~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_195c853721c149d79370956051caec90~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_8b8ee169ad954eef88654c0c9bac8546~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_9cea202ce9b34acd9d9aa3d056e56e48~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_71b42d13a620418998d84379057d5b1e~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b28154f3dca347c0be97fb80c906e7a0~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_363f73a568504eba8327a647266f36d3~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b8b67ec1694d4c1088e83bf8c02e84ab~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b2fcd9b14f8b46098660e3abda2bb651~mv2_d_5692_3200_s_4_2.png'
	},
	
	//70s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_134b7e4ce49b45959d57260f30218b5b~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_9143be8d51b24d01b54e7c9153d1c982~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_03e925106e154aa5842afdaac78f0c91~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_e7c8f2a705bb4fbc957f6a2e3c5fb4ec~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_44ee4923b85f4df392cc0fc56d645814~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_92ee9b003afd4f0d9906d4f1e5e0650b~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_0229bdfc97dc4ce5a28a298920b7891d~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_c98f3f3989634598940174944dee9eeb~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b4b71a69c0654b1f8cb0198c67721438~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_0cd35a5b1e6e4fd29882b8c0e8305804~mv2_d_5692_3200_s_4_2.png'
	},
	
	//60s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_27e1ac3766844834be6f4cd60ce318ad~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_28daf7d47795429a8f433abc02e08938~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_cd15df9cadc441488162d525bcf4e7c2~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_3e5f7f10fd6843d1b8267e05cb2cc5fe~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_c3188f654f9a4900a38def52825a44d1~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_f63104860b614afda826a26b2911ae53~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_75bea4540f4643f7b4777fd306c05573~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_5f32005c5dcd400f85a7364265309bef~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_aac931ed973e4a2988d70b7a4316d793~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_aeceac14d7cf43e4926bf8e41e8ed0c8~mv2_d_5692_3200_s_4_2.png'
	},
	
	//50s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_a00037d624c1445f9cc7235f118103f4~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_85b45389de32412db54be0b2066429b1~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_c4919a6472c54932995648df7a5b307e~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_649ba2f3aacd4ed8ae0cb83cefd2a073~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_a59e8fb15c3545d7929d64d2bc1c584c~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_6a3ed397afc448b89e9533a579cd45ee~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_6b485f3c17564c499ecd6d0f19d0cdd5~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_2822fb3ef25c49ba96368e852ec05224~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_704195c04a514d0cb28531d872cf7542~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_1de77e2088ca4592a38f86a4dc52f169~mv2_d_5692_3200_s_4_2.png'
	},
	
	//40s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_a6bb524bfb5b4bc9b14262170f725c2d~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_343d22f04ead43239b28f39440c3a42c~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_7f5c6b3ccae04aeab10eeae278f905a7~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_7039e86c06c3489dac6ef07e133ad6f5~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_a50a1b9139d542dd837ee9be074b34fe~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_d92ddbc503f447b9af988ac8fd2f8f5e~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b1322629616d4ec992151301449f3715~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_737fad805651498290353f82386f7339~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_9cd14ea955a9468caedd68448c57ef14~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_81c912778a2d41eab90f8607379cd160~mv2_d_5692_3200_s_4_2.png'
	},
	
	//30s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_26bfc17d72ba4ef5bf3a44fb7dfac264~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_f57ff1ef07554160ae5a810939edba15~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_067b28b4fae94526a04c1e5a7ef9e286~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_3cfe5426680b4274824c4797d4c1137b~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_9e3829cedaf34e6fb09870b470e12862~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_ce9a69cabe7148b9b2fc86d4288221a9~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_d808f6b74125427da3f8dc5154b29527~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_b5db470c79394cfbb8d11bdf65101b76~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_ab65b657933a468f8fec3f175c62cf30~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_1fa8c1844b064f71833fc1048c34c5ab~mv2_d_5692_3200_s_4_2.png'
	},
	
	//20s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_172d146a8d73489fa4da766cde91e33f~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_4a7e3a3016ae40c7a2c3ec8554faf510~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_bf5d941b2716440eb6a3ded0a4506af1~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_c15a5b61387345a68ae3e304dd7b7f29~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_9d14d9caa19f44da8ba39075380ae882~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_c98bab16929940d995b1d2d9627b805a~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_6f44f00ac89d40d5907a34d10d96879d~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_cab1b3d93aaf45ffb28cea59005459c1~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_f48c26f03f2640a48c24c93f83577769~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_a303767696e543909f310b08a7109324~mv2_d_5692_3200_s_4_2.png'
	},
	
	//10s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_109b0db4c6af46ff999be5d7e4bd7b45~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_612967ac02e94bf89d44674438e056d9~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_6b41311970e24c0a939df0709ed4e3d4~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_4f112e33ef054453a684af72d0be69b8~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_66a8f55159f644dba15d2fcb9e03ef3d~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_0ed0449e61414e00951775d11e8e0aad~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_f189c20c9dc9458e9dcf159b1fd7896f~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_cd336c14385d4a6c827e4ba6852b8316~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_7c3beeaee1514ee0beab627b6591ac02~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_5fd9a3abdd354034b8a17a216c9d4035~mv2_d_5692_3200_s_4_2.png'
	},
	
	//0s
	
	{
	  src: 'https://static.wixstatic.com/media/90a71b_6646317f54514e9eb3a373203eca41c2~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_ab37390cf5ab4b2a95ad251a3b959f64~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: "https://static.wixstatic.com/media/90a71b_6f36d4a9c735403e84adfb4e7e4161ef~mv2_d_5692_3200_s_4_2.png"
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_e3e73ba0780f4182949259b93eef7220~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_4bd4362d2d7a4bf7bff72976a70f7a4a~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_a8c74bcde9da43549959ac99763decd1~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_5a42078dc59f4fdf9564652cbb98b17b~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_53552f6664004b4499699799094c9e09~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_31b9ce1e29274e44ac29f49dcb1ac536~mv2_d_5692_3200_s_4_2.png'
	}, {
	  src: 'https://static.wixstatic.com/media/90a71b_0fb99887dfd54c92bdba4c61ea0d88de~mv2_d_5692_3200_s_4_2.png'
	}];
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Hi people'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Welcome to your new Gatsby site.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now go build something great.'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/page-2/' },
	      'Go to page 2'
	    )
	  );
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-31a728608477e3630179.js